import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getMakes, getMakesKey, getModels, getModelsKey } from '../../../../api-client/search'

function useFilter() {
  const defaultMakeOption = { value: 0, label: 'All makes' }
  const defaultModelOption = { value: 0, label: 'All models' }

  const [selectedMake, setSelectedMake] = useState(defaultMakeOption)
  const [makes, setMakes] = useState([])
  const [normalizedMakes, setNormalizedMakes] = useState({})

  const [selectedModel, setSelectedModel] = useState(defaultModelOption)
  const [models, setModels] = useState([])
  const [normalizedModels, setNormalizedModels] = useState({})

  const [minPrice, setMinPrice] = useState('')
  const [maxPrice, setMaxPrice] = useState('')
  const [sortType, setSortType] = useState({})

  const { data: makesData, isLoading: isMakesLoading } = useQuery({
    queryKey: getMakesKey,
    queryFn: getMakes,
  })

  const { data: modelsData, isLoading: isModelsLoading } = useQuery({
    queryKey: [getModelsKey, selectedMake?.value],
    queryFn: () => getModels({ makeId: selectedMake?.value }),
    enabled: selectedMake?.value !== 0,
  })

  useEffect(() => {
    if (!makesData) return

    const makesOptions = makesData.map(({ id, name }) => ({
      value: id,
      label: name,
    }))

    const normalized = makesData.reduce((prev, { id, name }) => {
      return { ...prev, [id]: name }
    }, { 0: 'All makes' })

    setSelectedMake(defaultMakeOption)
    setMakes([defaultMakeOption, ...makesOptions])
    setNormalizedMakes(normalized)
  }, [makesData])

  useEffect(() => {
    if (selectedMake?.value === 0) {
      setSelectedModel(defaultModelOption)
      setModels([])
      setNormalizedModels({})
      return
    }

    if (!modelsData) return

    const modelsOptions = modelsData.map(({ id, name }) => ({
      value: id,
      label: name,
    }))

    const normalized = modelsData.reduce((prev, { id, name }) => {
      return { ...prev, [id]: name }
    }, { 0: 'All models' })

    setSelectedModel(defaultModelOption)
    setModels([defaultModelOption, ...modelsOptions])
    setNormalizedModels(normalized)
  }, [modelsData, selectedMake])

  return {
    selectedMake,
    setSelectedMake,
    makes,
    normalizedMakes,
    isMakesLoading,
    defaultMakeOption,

    selectedModel,
    setSelectedModel,
    models,
    setModels,
    normalizedModels,
    isModelsLoading,
    defaultModelOption,

    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    sortType,
    setSortType,
  }
}

export default useFilter